// DO NOT MODIFY NESTED STRUCTURE
// These functions format the necessary data to post to the API

export function transformCheckInTrailer(data) {
  const transformedData = {
    truck: {
      carrier_name: data.carrierName,
      truck_plate: data.truckPlate,
      truck_condition: data.truckCondition,
      truck_condition_notes: data.truckConditionNotes,
      truck_number: data.truckNumber,
      odometer: data.odometer,
      truck_asset: data.truckAsset,
      origin: `${data.city}, ${data.state}, ${data.country}`,
      visitor: {
        first_name: data.firstName,
        last_name: data.lastName,
        reason: "Checking in a vehicle",
        category: "Driver",
        id_num: data.driverLicense ? data.driverLicense : null
      },
    },
    trailer_number: data.trailerNumber,
    license_plate: data.trailerPlate,
    trailer_condition: data.trailerCondition,
    trailer_condition_notes: data.trailerConditionNotes,
    trailer_dimensions: {
      length: data.trailerLength,
      width: data.trailerWidth,
      height: data.trailerHeight,
      standard: data.trailerDimension,
    },
    origin: `${data.city}, ${data.state}, ${data.country}`,
    customer: data.customer,
    is_loaded: data.isLoaded === "true",
    seal_number: data.sealNumber,
    internal_seal: data.internalSeal ? data.internalSeal.value : null,
    trailer_asset: data.trailerAsset,
  };
  return transformedData;
}

export function transformCheckInTruck(data) {
  const transformedData = {
    carrier_name: data.carrierName,
    truck_plate: data.truckPlate,
    truck_condition: data.truckCondition,
    truck_condition_notes: data.truckConditionNotes,
    truck_number: data.truckNumber,
    truck_asset: data.truckAsset,
    origin: `${data.city}, ${data.state}, ${data.country}`,
    odometer: data.odometer,

    visitor: {
      first_name: data.firstName,
      last_name: data.lastName,
      reason: "Checking in a vehicle",
      category: "Driver",
    },
  };
  return transformedData;
}

export function transformCheckOutTrailer(data) {
  const transformedData = {
    trailer: {
      id: data.trailerId,
      customer: data.customer,
      seal_number: data.sealNumber,
      trailer_condition: data.trailerCondition,
    },
    truck: {
      id: data.truckId,
      destination: `${data.city}, ${data.state}, ${data.country}`,
      truck_condition: data.truckCondition,
      odometer: data.odometer,
    },
    visitor: {
      id: data.visitorId,
    },
  };
  return transformedData;
}

export function transformCheckOutTruck(data) {
  const transformedData = {
    truck: {
      id: data.truckId,
      destination: `${data.city}, ${data.state}, ${data.country}`,
      truck_condition: data.truckCondition,
      odometer: data.odometer,
    },
    visitor: {
      id: data.visitorId,
    },
  };
  return transformedData;
}

const data = {
  truck: {
    carrier_name: "jfg",
    truck_plate: "YP62621",
    truck_condition: "good",
    truck_number: "JFG 103 ",
    odometer: "5",
    truck_asset: 175,
    origin: "San diego, California, USA",
    visitor: {
      first_name: "IBRAIN",
      last_name: "PITA ARZOLA",
      reason: "Checking in a vehicle",
      category: "Driver",
    },
  },
  trailer_number: "ATI-144 ",
  license_plate: "5019143",
  trailer_condition: "good",
  trailer_dimensions: {
    length: 53,
    width: 8.5,
    height: 13.5,
    standard: 53,
  },
  origin: "San diego, California, USA",
  customer: "",
  is_loaded: false,
  trailer_asset: 307,
  f15Trailer: {
    trailer_inspection: {
      chassis: {
        notes: "",
        value: true,
      },
      inOutDoors: {
        notes: "",
        value: true,
      },
      trailerFloor: {
        notes: "",
        value: true,
      },
      tires: {
        notes: "",
        value: true,
      },
      sideWalls: {
        notes: "",
        value: true,
      },
      frontWall: {
        notes: "",
        value: true,
      },
      ceiling: {
        notes: "",
        value: true,
      },
      pests: {
        notes: "",
        value: true,
      },
      garbage: {
        notes: "",
        value: true,
      },
      cleanliness: {
        notes: "",
        value: true,
      },
      filter: {
        notes: "",
        value: true,
      },
      humidity: {
        notes: "",
        value: true,
      },
      sealCondition: {
        value: true,
        notes: "",
      },
      refrigerator: {
        value: true,
        notes: "",
      },
    },
    seal_tests: {
      view_seal: null,
      verify_seal: null,
      tug_on_seal: null,
      twistTurn_seal: null,
    },
    anomalies: null,
  },
  f15Truck: {
    truck_inspection: {
      chassis: {
        notes: "",
        value: true,
      },
      bumper: {
        notes: "",
        value: true,
      },
      engine: {
        notes: "",
        value: true,
      },
      tires: {
        notes: "",
        value: true,
      },
      cabFloor: {
        notes: "",
        value: true,
      },
      ceiling: {
        notes: "",
        value: true,
      },
      fuelTank: {
        notes: "",
        value: true,
      },
      compartments: {
        notes: "",
        value: true,
      },
      airTank: {
        notes: "",
        value: true,
      },
      driveShafts: {
        notes: "",
        value: true,
      },
      fifthWheel: {
        notes: "",
        value: true,
      },
      exhaust: {
        notes: "",
        value: true,
      },
      pests: {
        notes: "",
        value: true,
      },
      garbage: {
        notes: "",
        value: true,
      },
      cleanliness: {
        notes: "",
        value: true,
      },
    },
    anomalies: null,
  },
  reason: "Checking in a trailer",
  employee_pin: "290",
};
